/*
---------------------------------------------------------
Copyright © 2026 Daniel Woik (DW E-Commerce). All rights reserved.
Custom-coded by DW E-Commerce. This code is licensed for use on
this store only, as part of the DW E-Commerce optimization service.
Copying, reselling, redistributing or using it on any other store
is not permitted without written permission.
---------------------------------------------------------
DW Kit:   Quick Add
Version:  1.2.1
Updated:  2026-10-14 — The dropdown list is never cut off by the popup: its height is limited to the free space above (or below) the field.
Source:   DW-Component-Library/Kits/Quick-Add

FUNCTION LOCKED. Any element with data-dw-quick-add="<handle>"
(and optionally data-dw-quick-add-url="<product url>") opens the
quick add. Content comes from sections/dw-quick-add-content.liquid.
Add to cart uses /cart/add.js; the DW cart drawer picks that up,
refreshes and opens by itself. Without the DW cart drawer the page
goes to the cart. Event: dw:quick-add:added (detail: item).
---------------------------------------------------------
*/
(function () {
  if (window.DWQuickAdd) return;

  var root = null;
  var body = null;
  var lastTrigger = null;
  var lockedByUs = false;
  var requestId = 0;

  function el() {
    if (!root || !root.isConnected) {
      root = document.getElementById('dw-quick-add');
      body = root ? root.querySelector('[data-dw-qa-body]') : null;
    }
    return root;
  }

  function loadingHtml() {
    return '<div class="dw-qa__loading" aria-hidden="true"><span></span></div>';
  }

  function lock() {
    var html = document.documentElement;
    if (getComputedStyle(html).overflow === 'hidden') return;
    html.classList.add('dw-qa-locked');
    lockedByUs = true;
  }

  function unlock() {
    if (!lockedByUs) return;
    document.documentElement.classList.remove('dw-qa-locked');
    lockedByUs = false;
  }

  function open(handle, url, trigger) {
    var r = el();
    if (!r || !body) {
      if (url) window.location.href = url;
      return;
    }
    lastTrigger = trigger || null;
    body.innerHTML = loadingHtml();
    r.hidden = false;
    r.setAttribute('aria-hidden', 'false');
    lock();
    var panel = r.querySelector('.dw-qa__panel');
    window.setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 30);

    var productUrl = url || ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'products/' + handle);
    var target;
    try {
      target = new URL(productUrl, window.location.origin);
    } catch (e) {
      return;
    }
    target.searchParams.set('section_id', 'dw-quick-add-content');
    var current = ++requestId;

    fetch(target.pathname + target.search, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('load');
        return response.text();
      })
      .then(function (html) {
        if (current !== requestId || r.hidden) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-dw-qa-content]');
        if (!content) throw new Error('content');
        body.innerHTML = '';
        body.appendChild(document.importNode(content, true));
        setup(body.querySelector('[data-dw-qa-content]'));
      })
      .catch(function () {
        if (current !== requestId) return;
        /* The content could not be loaded: go to the product page instead. */
        close();
        window.location.href = productUrl;
      });
  }

  function close() {
    var r = el();
    if (!r || r.hidden) return;
    requestId++;
    r.hidden = true;
    r.setAttribute('aria-hidden', 'true');
    if (body) body.innerHTML = loadingHtml();
    unlock();
    if (lastTrigger && typeof lastTrigger.focus === 'function' && lastTrigger.isConnected) {
      lastTrigger.focus({ preventScroll: true });
    }
  }

  /* Own dropdown list: opens directly under the field on every device.
     The hidden native select keeps the value, so the variant logic stays the same. */
  function closeLists(except) {
    var r = el();
    if (!r) return false;
    var closed = false;
    r.querySelectorAll('[data-dw-qa-list]:not([hidden])').forEach(function (list) {
      if (list === except) return;
      list.hidden = true;
      var btn = list.parentNode.querySelector('[data-dw-qa-dropdown]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      closed = true;
    });
    return closed;
  }

  function setupDropdown(fs) {
    var select = fs.querySelector('select');
    var btn = fs.querySelector('[data-dw-qa-dropdown]');
    var list = fs.querySelector('[data-dw-qa-list]');
    if (!select || !btn || !list) return;
    var items = function () { return Array.prototype.slice.call(list.querySelectorAll('.dw-qa__list-item')); };

    function openList() {
      closeLists(list);
      list.classList.remove('dw-qa__list--up');
      list.style.maxHeight = '';
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var body = btn.closest('[data-dw-qa-body]');
      if (body) {
        var room = body.getBoundingClientRect().bottom - btn.getBoundingClientRect().bottom;
        var above = btn.getBoundingClientRect().top - body.getBoundingClientRect().top;
        /* The popup body scrolls and cuts off anything outside it, so the list always fits into the free space.
           Mobile (bottom sheet): open upward unless there is almost no room above. Desktop: upward only when there is no room below. */
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        var natural = list.offsetHeight;
        var up = mobile ? above - 12 >= Math.min(natural, 120) : (room < natural + 8 && above > room);
        if (up) list.classList.add('dw-qa__list--up');
        var space = (up ? above : room) - 12;
        if (space > 0 && natural > space) list.style.maxHeight = Math.floor(space) + 'px';
      }
      var current = list.querySelector('[aria-selected="true"]') || items()[0];
      if (current) {
        current.focus();
        if (current.scrollIntoView) current.scrollIntoView({ block: 'nearest' });
      }
    }

    function choose(item) {
      select.value = item.getAttribute('data-value');
      select.dispatchEvent(new Event('change', { bubbles: true }));
      closeLists();
      btn.focus();
    }

    btn.addEventListener('click', function () {
      if (list.hidden) openList(); else { closeLists(); btn.focus(); }
    });

    btn.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openList();
      }
    });

    list.addEventListener('click', function (event) {
      var item = event.target.closest('.dw-qa__list-item');
      if (item) choose(item);
    });

    list.addEventListener('keydown', function (event) {
      var all = items();
      var index = all.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') { event.preventDefault(); (all[index + 1] || all[0]).focus(); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); (all[index - 1] || all[all.length - 1]).focus(); }
      else if (event.key === 'Home') { event.preventDefault(); all[0].focus(); }
      else if (event.key === 'End') { event.preventDefault(); all[all.length - 1].focus(); }
      else if ((event.key === 'Enter' || event.key === ' ') && index > -1) { event.preventDefault(); choose(all[index]); }
    });
  }

  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest || !event.target.closest('.dw-qa__select-wrap')) closeLists();
  }, true);

  function setup(content) {
    if (!content) return;
    var variants = [];
    try {
      variants = JSON.parse(content.querySelector('[data-dw-qa-variants]').textContent);
    } catch (e) {}
    var form = content.querySelector('[data-dw-qa-form]');
    var idInput = content.querySelector('[data-dw-qa-id]');
    var button = content.querySelector('[data-dw-qa-add]');
    var priceBox = content.querySelector('[data-dw-qa-price]');
    var image = content.querySelector('[data-dw-qa-image]');
    var error = content.querySelector('[data-dw-qa-error]');
    var fieldsets = Array.prototype.slice.call(content.querySelectorAll('[data-dw-qa-option]'));

    function selected() {
      return fieldsets.map(function (fs) {
        var select = fs.querySelector('select');
        if (select) return select.value;
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return values.every(function (value, i) { return v.options[i] === value; });
      });
    }

    function markAvailability(values) {
      fieldsets.forEach(function (fs, index) {
        var check = function (value) {
          return variants.some(function (v) {
            if (!v.available || v.options[index] !== value) return false;
            return values.every(function (chosen, i) { return i === index || v.options[i] === chosen; });
          });
        };
        fs.querySelectorAll('.dw-qa__value').forEach(function (label) {
          var input = label.querySelector('input');
          label.classList.toggle('dw-is-unavailable', !check(input.value));
        });
        fs.querySelectorAll('option, .dw-qa__list-item').forEach(function (option) {
          var value = option.value !== undefined && option.tagName === 'OPTION' ? option.value : option.getAttribute('data-value');
          var base = option.getAttribute('data-label') || option.textContent;
          option.setAttribute('data-label', base);
          var ok = check(value);
          option.textContent = ok ? base : base + ' – ' + (el().getAttribute('data-soldout-label') || 'Sold out');
          if (option.tagName !== 'OPTION') option.classList.toggle('dw-is-unavailable', !ok);
        });
      });
    }

    function update() {
      var values = selected();
      var variant = findVariant(values);
      if (error) { error.hidden = true; error.textContent = ''; }
      fieldsets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-dw-qa-selected]');
        if (label) label.textContent = values[i] || '';
        var dropLabel = fs.querySelector('[data-dw-qa-dropdown-label]');
        if (dropLabel) dropLabel.textContent = values[i] || '';
        fs.querySelectorAll('.dw-qa__list-item').forEach(function (item) {
          item.setAttribute('aria-selected', item.getAttribute('data-value') === values[i] ? 'true' : 'false');
        });
      });
      markAvailability(values);
      if (!variant) {
        button.disabled = true;
        button.textContent = el().getAttribute('data-unavailable-label') || 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? (el().getAttribute('data-add-label') || 'Add to cart') : (el().getAttribute('data-soldout-label') || 'Sold out');
      if (priceBox) {
        priceBox.innerHTML = variant.compare
          ? '<span class="dw-qa__price-sale">' + variant.price + '</span><s>' + variant.compare + '</s>'
          : '<span>' + variant.price + '</span>';
      }
      if (image && variant.image) image.src = variant.image;
    }

    content.addEventListener('change', update);
    fieldsets.forEach(setupDropdown);
    update();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;
      button.classList.add('dw-is-loading');
      var addUrl = (el().getAttribute('data-cart-add-url') || '/cart/add') + '.js';
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          var item = data && data.items ? data.items[0] : data;
          close();
          document.dispatchEvent(new CustomEvent('dw:quick-add:added', { detail: { item: item } }));
          /* The DW cart drawer refreshes and opens on its own. Without it, show the cart page. */
          if (!window.DWCart) window.location.href = el().getAttribute('data-cart-url') || '/cart';
        })
        .catch(function (data) {
          button.classList.remove('dw-is-loading');
          if (error) {
            error.textContent = (data && (data.description || data.message)) || 'This product could not be added.';
            error.hidden = false;
          }
        });
    });
  }

  /* Open from any quick add button (capture phase, before theme scripts). */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var trigger = target.closest('[data-dw-quick-add]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      open(trigger.getAttribute('data-dw-quick-add'), trigger.getAttribute('data-dw-quick-add-url'), trigger);
      return;
    }
    var r = el();
    if (r && !r.hidden && target.closest('[data-dw-qa-close]') && r.contains(target)) {
      event.preventDefault();
      close();
    }
  }, true);

  /* Window + capture: runs before the cart drawer's own keys, so Escape and Tab stay inside the quick add while it is open. */
  window.addEventListener('keydown', function (event) {
    var r = el();
    if (!r || r.hidden) return;
    if (event.key === 'Escape') {
      event.stopImmediatePropagation();
      var open = r.querySelector('[data-dw-qa-list]:not([hidden])');
      if (open) {
        closeLists();
        var btn = open.parentNode.querySelector('[data-dw-qa-dropdown]');
        if (btn) btn.focus();
        return;
      }
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    event.stopImmediatePropagation();
    var focusable = Array.prototype.filter.call(
      r.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }, true);

  window.DWQuickAdd = { open: open, close: close };
})();
